import { ucfirst } from '../utils';
export const sentence = (str) => {
    if (!str) {
        return '';
    }
    return ucfirst(str.endsWith('.') ? str : `${str}.`);
};
